export default __webpack_public_path__ + "static/media/star.84a9ca81.svg";